import type { ReactElement, ReactNode } from 'react';
import { useState } from 'react';
import { NextButton, PreviewImage, PreviousButton } from './PreviewImage';
import styles from './PreviewImages.module.scss';

export type PreviewImageType = {
  url: string | null;
  placeholder: string | null;
};

type Props = {
  images: Array<PreviewImageType> | undefined;
  linkWrapper: (props: { children: ReactNode }) => ReactElement;
};

export function PreviewImages(props: Props): ReactNode {
  const { images = [], linkWrapper } = props;
  const [index, setIndex] = useState(0);

  const image = images[index];
  const showControls = images.length > 1;

  const nextImage = () => {
    setIndex(nextIndex(index, images.length));
  };

  const prevImage = () => {
    setIndex(prevIndex(index, images.length));
  };

  return (
    <div className={styles.container}>
      {linkWrapper({ children: <PreviewImage image={image} /> })}
      {showControls && <NextButton handleClick={nextImage} />}
      {showControls && <PreviousButton handleClick={prevImage} />}
    </div>
  );
}

function nextIndex(index: number, imagesCount: number): number {
  return (index + 1) % imagesCount;
}

function prevIndex(index: number, imagesCount: number): number {
  return (index + imagesCount - 1) % imagesCount;
}
